import { Outlet } from "react-router-dom";
import FoodPulseTopNav from "@/components/FoodPulseTopNav";

/**
 * Shared layout for every `/food-pulse/*` route so the sticky top nav
 * (with cascading Country → State → City picker) travels with the user
 * across Discover, Farms & Stores, Community, etc.
 *
 * Includes a skip-to-content link for keyboard and screen-reader users
 * (WCAG 2.2 AA — SC 2.4.1).
 */
export default function FoodPulseLayout() {
  return (
    <div className="min-h-screen bg-white" data-testid="fp-layout">
      {/* Skip-to-content — visually hidden until focused */}
      <a
        href="#fp-main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:rounded-lg focus:bg-emerald-700 focus:px-4 focus:py-2 focus:text-white focus:shadow-lg focus:outline-none"
        data-testid="fp-skip-to-content"
      >
        Skip to main content
      </a>
      <FoodPulseTopNav />
      <main id="fp-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}

